export const initialState = {
    data: {
        items: [],
    },
    loading: {
        isLoadingBackdrop: true,
    },
    error: null,
};

export function dashboardPageReducer(state, action) {
    switch (action.type) {
        case "SET_ITEMS":
            return {
                ...state,
                data: {
                    ...state.data,
                    items: action.payload || [],
                },
            };
        case "SET_LOADING":
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.key]: action.payload.value,
                },
            };
        case "SET_ERROR":
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}
